import ClientType from '@/models/ClientType';

export default class ClientTypeRepository {
    public static getAll() {
        return ClientType.all();
    }

    public static getById(id: string) {
        return ClientType.query().whereId(id).withAll().first();
    }

    public static getByType(type: string) {
        const types = ClientType.all();

        if (!type) {
            return types;
        }

        return ClientType.query().where('type', type).all();
    }
}
